import {Component, computed, inject, input} from '@angular/core';
import {SeiService} from '@core/services/sei.service';

/**
 * Processo com o número SEI clicável: com a extensão SisNot ↔ SEI instalada,
 * clicar no número abre o processo no SEI, na aba do SEI (ou numa nova). Quem
 * trata o clique é a extensão (data-sei-numero). Sem a extensão, ou sem número
 * SEI no texto, sem a integração com o SEI liberada ou sem o SEI conectado
 * (ver SeiService.ativo), mostra o texto normal.
 *
 * modo "texto": mostra o texto todo, com o número como link (tabelas).
 * modo "link": só um link "Abrir no SEI" (ao lado de um campo de digitar).
 */
@Component({
  selector: 'app-abrir-sei',
  template: `
    @if (modo() === 'texto') {
      @if (partes(); as p) {
        {{ p.antes }}<a [attr.data-sei-numero]="p.numero"
           (click)="$event.preventDefault(); $event.stopPropagation()"
           class="text-black dark:text-white underline underline-offset-2 cursor-pointer">{{ p.numero }}</a>{{ p.depois }}
      } @else {
        {{ texto() || vazio() }}
      }
    } @else {
      @if (partes(); as p) {
        <a [attr.data-sei-numero]="p.numero"
           (click)="$event.preventDefault(); $event.stopPropagation()"
           class="ml-1 text-xs font-semibold text-black dark:text-white underline cursor-pointer">
          <i class="pi pi-external-link text-[10px]"></i> Abrir no SEI
        </a>
      }
    }
  `,
})
export class AbrirSei {
  private sei = inject(SeiService);

  /** Texto do campo Processo (o número SEI é procurado dentro dele). */
  texto = input<string | null | undefined>();
  modo = input<'texto' | 'link'>('texto');
  /** O que mostrar quando o texto está vazio. */
  vazio = input<string>('—');

  partes = computed(() => {
    const texto = this.texto() ?? '';
    const numero = this.sei.ativo() ? this.sei.numero(texto) : null;
    if (!numero) return null;
    const i = texto.indexOf(numero);
    return {antes: texto.slice(0, i), numero, depois: texto.slice(i + numero.length)};
  });
}
